import Alpine from 'alpinejs';

export const siteNav = Alpine.data('siteNav', () => ({
    mobileOverlayIsOpen: false,
    isAnimating: false,
    isMobile:  window.outerWidth > 1024 ? false : true,
    body: {
        ['@keydown.escape']() {
            this.mobileOverlayIsOpen = false;
        },
        ['@resize.window.debounce']() {
            if(window.outerWidth > 1024) {

                this.isMobile = false;

                if(this.mobileOverlayIsOpen) {
                    this.mobileOverlayIsOpen = false;
                }

            } else {

                this.isMobile = true;
                
            }
        },
        [':class']() {
            return {
                'overflow-hidden nav-is-open': this.mobileOverlayIsOpen
            }
        }
    },
    mainNavigationContainer: {
    },
    mainNavigation: {
    },
    navBackdrop: {
        ['@click']() {
            this.closeNav();
        },
        ['x-show']() {
            return this.isMobile;
        }
    },
    hamburger: {
        ['@click']() {
            this.mobileOverlayIsOpen = !this.mobileOverlayIsOpen;
        },
        [':class']() {
            return {
                'fixed top-1 right-1 active': this.mobileOverlayIsOpen,
            }
        }
    }
}));

export const navDropdown = Alpine.data('navDropdown', () => ({
    isOpen: false,
    trigger: {
        ['@click']() {
            this.isOpen = !this.isOpen;
        },
        [':aria-expanded']() {
            return this.isOpen.toString();
        },
        [':class']() {
            return { 
                'dropdown--is-open': this.isOpen 
            }
        }
    },
    navDropdownParent: {
        ['@click.away']() {
            this.isOpen = false;
        }
    },
    childMenu: {
        [':aria-expanded']() {
            return this.isOpen.toString();
        },
        ['x-transition:enter']: 'transition duration-200',
        ['x-transition:enter-start']: 'opacity-0',
        ['x-transition:enter-end']: 'opacity-100',
        ['x-transition:leave']: 'transition duration-100',
        ['x-transition:leave-start']: 'opacity-100',
        ['x-transition:leave-end']: 'opacity-0',
        ['x-show']() {
            return this.isOpen;
        },
    },
    icon: {
        [':class']() {
            return {
                '-scale-y-[1]': this.isOpen
            }
        }
    }
}));